module.exports = __webpack_public_path__ + "media/icons/nav-arrow-right-blue-68bcb6b4.svg";